type ProviderSearch = {
  init: () => void;
};

/**
 * Adds the clear-search behavior to the server-rendered provider-landing search
 * form. This form is NOT a React/Coveo search — it submits a native GET to the
 * external Kyruus site — so the clear button is wired up here in vanilla JS
 * rather than in a React component. It mirrors the React search inputs: clicking
 * the button empties the input and returns focus to it. The button's visibility
 * (only shown once the input has text) is handled purely in CSS via
 * `:placeholder-shown`, so there is nothing to toggle here.
 */
const ProviderSearch: ProviderSearch = {
  init() {
    const containers = document.querySelectorAll<HTMLElement>('[data-hook=providerSearch]');
    if (!containers.length) return;

    containers.forEach((container) => {
      const input = container.querySelector<HTMLInputElement>('[data-hook=providerSearchInput]');
      const clearButton = container.querySelector<HTMLButtonElement>('[data-hook=providerSearchClear]');
      if (!input || !clearButton) return;

      clearButton.addEventListener('click', () => {
        input.value = '';
        input.focus();
      });
    });
  },
};

export default ProviderSearch;
